// Google Analytics 4 (gtag.js) — frontend-only, loaded after cookie consent.
// Measurement ID comes from the linked Google Analytics connector.

const measurementId = import.meta.env
  .VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY as string | undefined;

type GtagFn = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: GtagFn;
  }
}

let initialized = false;

export function isAnalyticsEnabled() {
  return Boolean(measurementId) && typeof window !== "undefined";
}

export function initAnalytics() {
  if (initialized || !isAnalyticsEnabled()) return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  const gtag: GtagFn = (...args: unknown[]) => {
    window.dataLayer!.push(args);
  };
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", measurementId!);
}

// SPA route changes: gtag only auto-tracks the initial page load.
export function trackPageView(path: string) {
  if (!initialized || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", { page_path: path });
}
